<mat-form-field
  #input
  [appearance]="appearance"
  class="w-full relative"
  [floatLabel]="!control.value ? 'always' : 'auto'"
>
  <mat-label [attr.for]="id"> {{ label }}</mat-label>
  <input
    [autocomplete]="autocomplete || (arePasswordField ? 'off' : 'on')"
    matInput
    [ngClass]="fieldClass"
    [attr.id]="id"
    [attr.name]="id"
    [placeholder]="placeholder"
    [formControl]="control"
    [type]="arePasswordField ? (hide ? 'password' : 'text') : type"
    [attr.maxlength]="maxlength"
    (keyup)="checkCapsLock($event)"
    (keyup)="checkCapsLock($event)"
    (keydown)="checkCapsLock($event)"
    (focus)="checkCapsLock($event)"
  />

  @if (arePasswordField && capsLockOn) {
    <mat-icon
      matSuffix
      class="select-none"
      [matTooltip]="'Attenzione: MAIUSC inserito'"
      >keyboard_capslock</mat-icon
    >
  }
  @if (arePasswordField) {
    <mat-icon matSuffix (click)="toggleHidePassword()" class="cursor-pointer">{{
      hide ? 'visibility_off' : 'visibility'
    }}</mat-icon>
  }
  @if (unita) {
    <span matSuffix class="mr-2">{{ unita }}</span>
  }
  @if (showSearchIcon) {
    <mat-icon matSuffix>search</mat-icon>
  }
</mat-form-field>
<mat-error siatErrorField [control]="control" [label]="label"></mat-error>
